import { Box, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: 12,
        
    },
    label: {
        color: '#949494',
        marginBottom: 3,
    },
    labelError: {
        color: '#f44335',
    },
    customTextField: {
        color: '#949494',
        '& .MuiOutlinedInput-root': {
            height: '100%',
        },
    },
    singleLine: {
        height: 35,
    },
}));

const CustomTextBox = ({ 
    label, 
    onChange, 
    value, 
    error, 
    InputProps, 
    rows, 
    type = "text", // 👈 default нь text
    onlyNumber = false // 👈 нэмэлт prop
}) => {
    const classes = useStyles();

    const handleChange = (e) => {
        let newValue = e.target.value;
        if (onlyNumber) {
            // зөвхөн 0-9 хадгална
            newValue = newValue.replace(/[^0-9]/g, '');
        }
        onChange(newValue);
    };

    return (
        <Box className={classes.root}>
            <Typography
                variant={'h6'}
                className={clsx({
                    [classes.label]: true,
                    [classes.labelError]: error,
                })}
            >
                {label}
            </Typography>
            <TextField
                variant="outlined"
                value={value}
                onChange={handleChange}
                className={clsx({
                    [classes.customTextField]: true,
                    [classes.singleLine]: !rows,
                })}
                error={error}
                InputProps={InputProps}
                type={onlyNumber ? "text" : type} 
                inputMode={onlyNumber ? "numeric" : "text"}
                rows={rows ? rows : 1}
            />
        </Box>
    );
};

export default CustomTextBox;
